import { render, staticRenderFns } from "./studySer.vue?vue&type=template&id=f60c5cf4&"
import script from "./studySer.vue?vue&type=script&lang=js&"
export * from "./studySer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports